import { money } from '../payments/downPaymentCards';

export interface DownPaymentPostingCheck {
  isIndirect: boolean;
  isLease: boolean;
  /** For a lease: why its amount due at signing can't be used (getLeaseAmountDueRefusal), or undefined. */
  leaseRefusal?: string;
  /** The down payment the quote needs (getDownPaymentFromQuote). */
  amountDue: number | undefined;
  /** The down payments received. */
  paid: number;
  /** AMS 2000's REQUIRE_DP from the configuration; missing means on. */
  requireDownPayment: boolean | undefined;
}

/**
 * Why the deal can't post because of its down payment, or undefined (LOS card down payments B3, C2, C5, C6):
 * - Indirect deals collect theirs outside the LOS and are never checked.
 * - A lease needs a solved quote whose Total Down covers the deferred down payments, whatever REQUIRE_DP says.
 * - With REQUIRE_DP on, the down payments received must equal the amount due, to the cent.
 */
export const getDownPaymentPostingRefusal = (check: DownPaymentPostingCheck): string | undefined => {
  if (check.isIndirect) return undefined;
  if (check.isLease && check.leaseRefusal) return check.leaseRefusal;
  if (check.requireDownPayment === false) return undefined;

  const due = check.amountDue ?? 0;
  if (Math.round(due * 100) === Math.round(check.paid * 100)) return undefined;
  return check.isLease
    ? `The total down payment paid (${money(check.paid)}) is different than the Total Down due at signing from the last solved quote (${money(due)}). Either adjust the quote or make another payment.`
    : `The total down payment paid (${money(check.paid)}) is different than the down payment needed from the last solved quote (${money(due)}). Either adjust the down payment required on the quote or make another payment.`;
};
